/* iPhumat — diagnostic interactif "Réparer / Acheter / Revendre".
 * Logique simple et transparente, modifiable sans dépendances.
 */
(function () {
  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('.diag-step'));
    var resultBox = root.querySelector('[data-result]');
    var progress = root.querySelector('[data-progress]');
    var answers = {};
    var current = 0;

    function show(i) {
      steps.forEach(function (s, idx) { s.hidden = idx !== i; });
      resultBox.hidden = true;
      if (progress) progress.style.width = Math.round(((i + 1) / (steps.length + 1)) * 100) + '%';
    }

    function decide() {
      // Recommandation : pondère âge, envie de changer et type de panne.
      var age = answers.age;       // new | mid | old
      var upg = answers.upgrade;   // no | maybe | yes
      var issue = answers.issue;   // screen, battery, ... water

      var result = 'repair';
      var heavy = (issue === 'water' || issue === 'software');

      if (upg === 'yes') {
        result = (age === 'old') ? 'buy' : 'trade';
      } else if (age === 'old' && (heavy || upg === 'maybe')) {
        result = 'buy';
      } else if (age === 'mid' && upg === 'maybe' && heavy) {
        result = 'trade';
      } else {
        result = 'repair';
      }

      ['repair', 'buy', 'trade'].forEach(function (k) {
        var el = resultBox.querySelector('[data-result-' + k + ']');
        if (el) el.hidden = (k !== result);
      });
      steps.forEach(function (s) { s.hidden = true; });
      resultBox.hidden = false;
      if (progress) progress.style.width = '100%';
    }

    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input.name) return;
      answers[input.name] = input.value;
      // Avance automatiquement à l'étape suivante.
      if (current < steps.length - 1) {
        current += 1;
        show(current);
      } else {
        decide();
      }
    });

    var restart = root.querySelector('[data-restart]');
    if (restart) {
      restart.addEventListener('click', function () {
        answers = {};
        current = 0;
        root.querySelectorAll('input[type="radio"]').forEach(function (r) { r.checked = false; });
        show(0);
      });
    }

    show(0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-diagnostic]').forEach(init);
  });
})();
